import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import IconButton from '@mui/material/IconButton';

export const ImageCarouselControl = ({
  direction,
  onClick,
  disabled,
  'data-testid': dataTestId,
}: {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled: boolean;
  'data-testid'?: string;
}) => {
  return (
    <IconButton
      data-testid={dataTestId}
      disabled={disabled}
      onClick={onClick}
      size="large"
      sx={{
        bgcolor: 'white',
        borderRadius: 2,
        color: 'black',
        fontWeight: 'bold',
      }}
    >
      {direction === 'left' ? (
        <KeyboardArrowLeft data-testid="left-arrow" />
      ) : (
        <KeyboardArrowRight data-testid="right-arrow" />
      )}
    </IconButton>
  );
};
